export default __webpack_public_path__ + "static/media/alert-fixed-persistence.5d450d12.svg";